import React, { useContext } from 'react';
import { LanguageContext } from '../LanguageContext';
import { getProjectsData } from '../data';
import { ArrowRightIcon } from '../icons/ArrowRightIcon';
import { ProjectCard } from '../ProjectCard';
import Button from '../Button';

const Projects: React.FC<{ openChat: (source?: string) => void }> = ({ openChat }) => {
    const { t } = useContext(LanguageContext);
    const projectsData = getProjectsData(t);
    return (
        <section id="projects" className="py-20 sm:py-32 bg-gray-50 dark:bg-gray-900/50 scroll-mt-20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center">
                    <h2 className="text-3xl font-bold tracking-tight sm:text-4xl text-gray-900 dark:text-gray-50">{t?.projects?.title || ''}</h2>
                    <p className="mt-4 text-lg text-gray-600 dark:text-gray-400">{t?.projects?.description || ''}</p>
                </div>

                <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-8">
                    {projectsData.filter(Boolean).map((project: any, index: number) => <ProjectCard key={project?.title || index} {...project} />)}
                </div>

                <div className="mt-20 text-center">
                    <Button onClick={() => openChat('projects_cta')} variant="secondary" className="inline-flex items-center gap-x-2">
                        {t?.assistant?.title || 'AI Assistant'}
                        <ArrowRightIcon className="w-5 h-5" />
                    </Button>
                </div>
            </div>
        </section>
    );
};

export default Projects;
